// extracted by mini-css-extract-plugin
export default {"root":"InboxSearchForm_root__iqbab","sortyByWrapper":"InboxSearchForm_sortyByWrapper__GTsha","sortyBy":"InboxSearchForm_sortyBy__7fAC- marketplaceSmallFontStyles"};